import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RoutePath } from 'app/routing/routes';
import { RoleNames } from 'app/_models';
import { UserService } from 'app/_services/user.service';

@Injectable({
    providedIn: 'root',
})
export class HomepageGuard implements CanActivate {
    constructor(private router: Router, private userService: UserService) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const user = this.userService.UserValue;
        const role = user?.CurrentRole.roleName;

        let path = `/${RoutePath.Home}`;
    
        if (user && role) {
            switch(role) {
                case RoleNames.DistrictWebsite:
                    path = `/${RoutePath.Home}`;
                    break;
                case RoleNames.Legislative:
                    path = `/${RoutePath.LegislationInfo}`;
                    break;
                default:
                    path = `/${RoutePath.Home}`;
                    break;
            }

            this.router.navigate([path], { queryParams: { returnUrl: state.url } });
            return true;
        }

        this.router.navigate([RoutePath.Login], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
